'use strict'

import React from 'react'
import { Provider } from 'react-redux'
import store from '../store'
import { BrowserRouter, Route } from 'react-router-dom'
import { fetchCustomEmojis } from '../actions/custom_emojis'
import { fetchChatConversationUnreadCount } from '../actions/chat_conversations'
import { routerChange } from '../actions/router'
import { hydrateStore } from '../actions/store'
import { connectAltStream } from '../actions/streaming'
import { saveWindowDimensions } from '../actions/settings'
import { hydrateActiveReactions } from '../actions/reactions'
import { hydrateGlobalStatusContexts } from '../actions/status_contexts'
import initialState from '../initial_state'
import { me } from '../initial_state'
import UI from '../features/ui'
import ErrorBoundary from '../components/error_boundary'
import Display from './display'
import { fetchBlocksAndMutes } from '../actions/blocks'
import { fetchFilters } from '../actions/filters'
import { fetchCallToActions } from '../actions/call_to_actions'

export { store }
const hydrateAction = hydrateStore(initialState)

import MusculaLog from '@muscula.com/muscula-webapp-js-logger';

store.dispatch(hydrateAction)
store.dispatch(fetchCustomEmojis())
store.dispatch(fetchCallToActions())
store.dispatch(fetchChatConversationUnreadCount())
store.dispatch(saveWindowDimensions())
store.dispatch(hydrateActiveReactions())
if (me) store.dispatch(hydrateGlobalStatusContexts())

class GabSocialMount extends React.PureComponent {
  componentDidMount() {
    MusculaLog.Init('Mck6Mwno1u')
    window.MusculaLog = MusculaLog
    // this runs before other things or else they can prevent us bubbling up
    window.addEventListener('popstate', details => store.dispatch(routerChange({ popstate: true, ...details })))

    if (!!me) {
      const metricsUpdated = Number(localStorage.getItem('metrics_updated')) || null;
      if (!metricsUpdated || Date.now() > metricsUpdated + 60000) {
        localStorage.setItem('metrics_updated', Date.now())
        store.dispatch(fetchBlocksAndMutes())
      }
      store.dispatch(fetchFilters())
    }

    this.handleResize()
    window.addEventListener('resize', this.handleResize, false)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize, false)
  }

  handleResize = () => {
    store.dispatch(saveWindowDimensions())
  }

  routerRef = r => {
    if (r && r.history && r.history.listen) {
      r.history.listen(details => store.dispatch(routerChange(details)))
    }
  }

  render () {
    return (
      <BrowserRouter ref={this.routerRef}>
        <Route path='/' component={UI} />
      </BrowserRouter>
    )
  }

}

export default class GabSocial extends React.PureComponent {

  componentDidMount() {
    
    if (!!me) {
      localStorage.removeItem('streamingDisconnectReason');
      store.dispatch(connectAltStream(store.dispatch))
    }

    console.log('%cGab Social ', [
      , 'color: #30CE7D'
      , 'display: block'
      , 'line-height: 80px'
      , 'font-family: system-ui, -apple-system, BlinkMacSystemFont, Roboto, Ubuntu, "Helvetica Neue", sans-serif'
      , 'font-size: 36px'
      , 'text-align: left'
      , 'font-weight: 800'
    ].join(';'))
    console.log('%cThis is a browser feature intended for developers.\nIf someone told you to copy and paste something here it is a scam and will give them access to your Gab account. ', [
      , 'color: #000'
      , 'display: block'
      , 'line-height: 30px'
      , 'font-family: system-ui, -apple-system, BlinkMacSystemFont, Roboto, Ubuntu, "Helvetica Neue", sans-serif'
      , 'font-size: 20px'
      , 'text-align: left'
      , 'font-weight: 600'
    ].join(';'))
  }

  componentWillUnmount () {
    if (this.disconnect) {
      this.disconnect()
      this.disconnect = null
    }
  }

  render () {
    return (
      <Provider store={store}>
        <Display>
          <ErrorBoundary>
            <GabSocialMount />
          </ErrorBoundary>
        </Display>
      </Provider>
    )
  }

}
